/* KRUX Sales-Section Cues.
   See assets/krux-section-cues.css for the visual styles.

   Shimmer: replays every time a heading scrolls into view (by design
   — the point is to catch the eye and mark the moment each time,
   not just on first load).

   Hero REDLINE word: on top of the scroll-in sweep, it sweeps again
   every 6 seconds while it is on screen (stops when scrolled away;
   no animation for reduced-motion users).

   Glow: triggers once, then keeps pulsing continuously once started
   — no need to retrigger since the effect itself doesn't stop.

   CTA shimmer: the main red homepage buttons (SHOP CAPS / HOODIES /
   BEANIES, JOIN THE FOUNDING CREW) get the same 2s shimmer as the hero
   SHOP REDLINE button, running only while on screen. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupShimmer(selector, activeClass) {
    var targets = document.querySelectorAll(selector);
    if (targets.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add(activeClass); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          // Restart the animation every time it re-enters: remove the
          // class, force a reflow, then re-add it on the next frame.
          el.classList.remove(activeClass);
          void el.offsetWidth;
          el.classList.add(activeClass);
        } else {
          el.classList.remove(activeClass);
        }
      });
    }, { threshold: 0.4 });

    targets.forEach(function (el) { io.observe(el); });
  }

  // Repeat the sweep every `ms` while the element is on screen.
  function setupShimmerLoop(selector, activeClass, ms) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll(selector);
    if (targets.length === 0) return;
    var timers = new WeakMap();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        var t = timers.get(el);
        if (t) { clearInterval(t); timers.delete(el); }
        if (entry.isIntersecting) {
          timers.set(el, setInterval(function () {
            if (document.hidden) return;
            el.classList.remove(activeClass);
            void el.offsetWidth;
            el.classList.add(activeClass);
          }, ms));
        }
      });
    }, { threshold: 0.4 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function setupGlowOnce(selector, activeClass) {
    var targets = document.querySelectorAll(selector);
    if (targets.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add(activeClass); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(activeClass);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    targets.forEach(function (el) { io.observe(el); });
  }

  function setupCtaShimmer() {
    var targets = document.querySelectorAll('.kp__cta:not(.kp__cta--off), .kc__submit');
    if (targets.length === 0) return;
    targets.forEach(function (el) { el.classList.add('krux-cta-shimmer'); });
    if (reduceMotion) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-shimmering'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('is-shimmering');
        else e.target.classList.remove('is-shimmering');
      });
    }, { threshold: 0.6 });
    targets.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupShimmer('.krux-shimmer', 'is-shimmer');
    setupShimmerLoop('.krux-hero__headline .krux-shimmer', 'is-shimmer', 6000);
    setupGlowOnce('.krux-glow-target', 'is-glowing');
    setupCtaShimmer();
  });
})();
